export function homePagesHash() {
    let hash = window.location.hash;

    if (hash) {
        setTimeout(() => {
            $('html, body').animate({
                scrollTop: $(hash).offset().top - $('.header').innerHeight()
            }, 700);
        }, 100)
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/homePageHash.js